import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link, SpacerVertical, Typography } from '@klarna/bubble-ui';

import { arrayTranslator } from '@/selectors/utils';

const SubtitlesWithLinks = ({ tPrefix, parts }) => (
  <span>
    {parts.map(({ link, text }, index) => (
      <Typography
        textToken="text-style/text/paragraphs/tall/medium"
        key={`text-with-links-${tPrefix}-${index}`}
      >
        {link ? (
          <Link textToken="text-style/text/labels/body/medium" href={link}>
            {text}
          </Link>
        ) : (
          text
        )}
        {index < parts.length - 1 ? <SpacerVertical spaceToken="space/300" /> : null}
      </Typography>
    ))}
  </span>
);

SubtitlesWithLinks.propTypes = {
  tPrefix: PropTypes.string.isRequired,
  parts: PropTypes.array,
};

export default connect((state, { tPrefix }) => ({
  parts: arrayTranslator(tPrefix)(state) || [],
}))(SubtitlesWithLinks);
